import { Link } from "react-router-dom";
import { Home, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function NotFoundPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA] pt-20">
      <div className="max-w-md mx-auto container-padding text-center">
        <div className="text-9xl font-bold text-gradient mb-4">404</div>
        <h1 className="heading-2 mb-4">Página no encontrada</h1>
        <p className="body-text mb-8">
          Lo sentimos, la página que buscas no existe o ha sido movida.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/">
            <Button className="btn-primary" data-testid="404-home-button">
              <Home className="mr-2 h-4 w-4" />
              Ir al inicio
            </Button>
          </Link>
          <Button
            variant="outline"
            className="btn-secondary"
            onClick={() => window.history.back()}
            data-testid="404-back-button"
          >
            <ArrowLeft className="mr-2 h-4 w-4" />
            Volver atrás
          </Button>
        </div>
      </div>
    </div>
  );
}
